document.addEventListener('DOMContentLoaded', function() {
    "use strict";

    const img_wait = new Image();
    img_wait.src = "/v5_test_images/order/ajax-loader-big.gif";
    const page_type = document.body.getAttribute('data-page_type');
    const browser_type =  document.body.getAttribute('data-browser_type');
    const mobile_path_addin = browser_type == 'mobile' ? '/mobile' : '';

    let $msg = '';
    /**
     * General
     */
    const form = page_type == 'basket' ? document.getElementById("basket_form") : document.getElementById("order_form");
    const lang = document.documentElement.getAttribute('lang');
    

    const noEnterSubmitElements = document.querySelectorAll('.noEnterSubmit');
    noEnterSubmitElements.forEach(function(element) {
        element.addEventListener('keydown', function(e) {
            if (e.key === 'Enter' || e.keyCode === 13) {
                // Deselects field when hitting CR
                e.target.blur();
                // Avoid clicking on submit button (and sending GET to redirect to next page)
                return false;
            }
        });
    });

    /**
     * Basket page
     */
    if (page_type == 'basket') {

        // Select full text content of input when clicking in input field, and update fields when changed
        const qtyInputs = document.querySelectorAll('.qty_input, .promo_code_input');
        qtyInputs.forEach(function(input) {
            input.addEventListener('click', function(e) {
                e.target.select();
            });
        });

        // Refresh Selected country (DOM is loaded from cache when coming back from Order page)
        const selects = document.getElementsByTagName('select');
        for (const currentSelect of selects) {
            const selectedOption = currentSelect.querySelector('option[selected]');
            if (selectedOption) {
                currentSelect.value = selectedOption.value;
            }
        }

        const ajaxInputs = document.querySelectorAll('.ajax_input');
        ajaxInputs.forEach(function(input) {
            input.addEventListener('change', function(event) {
                const targetName = event.target.getAttribute('name');
                updateBasketCart(targetName, form);
            });
        });
    }

    /**
     * Order page
     */
    if (page_type == 'order') {
        /**
         * Manage fields visibility dynamically
         * Validates inputs
         * Update page when form fields are changed
         * 
         * The Delivery Country should be set in the Basket page, and unchangeable in the Order page
         * Show warning if the billing country is different from the delivery one
         */

        const delivery_ckbox = document.getElementById("special_delivery_check");
        const delivery_country = document.getElementById('del_country');
        const billing_country = document.getElementById('bill_country');
        if (billing_country.value !== delivery_country.value) {
            show_delivery_address();
        }

        const ajaxInputs = document.querySelectorAll('.ajax_input');

        /* We manage the Ajax changes */
        ajaxInputs.forEach(function(input) {
            input.addEventListener('change', function(event) {
                const targetName = event.target.getAttribute('name');
                const different_countries = billing_country.value !== delivery_country.value;

                /* Manage the warning if the billing country is different from the delivery one */
                if (targetName == 'bill_country' && different_countries) {
                    const countrySelector = document.getElementById('del_country');
                    const delCountryString = countrySelector.querySelector(`option[value="${delivery_country.value}"]`).textContent;
                    const billCountryString = countrySelector.querySelector(`option[value="${billing_country.value}"]`).textContent;

                    if (lang === 'fr') {
                        // TODO: change value for the name of the country
                        $msg = `<p>Vous avez choisi le pays '${billCountryString}' pour la facturation, qui est différent du pays de livraison '${delCountryString}'.</p><p> Si c'est une erreur, vous pouvez changer le pays de livraison en cliquant ici: <a href='${mobile_path_addin}/commande/votre-panier/'>retourner au panier</a>, pour recalculer les frais d'expédition et les taxes.</p>`;
                    } else {
                        $msg = `<p>You have chosen the country '${billCountryString}' for invoicing, different from '${delCountryString}' chosen for delivery. If it is not your intention, you can change the delivery country, by clicking here <a href='/en${mobile_path_addin}/order/your-basket/'>to return to the basket</a> and recalculate the shipping and taxes.`;
                    }
                    show_delivery_address();
                    vb_alert($msg);
                }

                /** 
                 * If the special_delivery box is checked, we show the block, if unchecked we hide it
                 * If it is unchecked, we hide the block, unless the countries are different
                 */
                if (targetName == 'special_delivery_check') {
                    if (delivery_ckbox.checked || different_countries) {
                        document.getElementById('special_delivery').style.display = 'block';
                        delivery_ckbox.checked = true;
                    } else {
                        document.getElementById('special_delivery').style.display = 'none';
                    }
                }
                /**
                 * If the Delivery block is hidden, we set the delivery Country to the Billing Country //TODO: when do we update the basket ?
                 * 
                 * NO: THE WAY TO GO IS KEEP THE DESTINATION BOX DISPLAYED AS LONG AS THE COUNTRIES ARE DIFFERENT. addresses can still be different with the same country though.
                 */
                // if (delivery_ckbox.style.display == 'none') {
                //     document.getElementById("del_country").value = document.getElementById("bill_country").value;
                // }

                /* If the changed field is "required", we validate its content */
                if (event.target.classList.contains('required')) {
                    const requiredInputs = document.querySelectorAll('#payment_box_1 .required');
                    let addressesInError = false;
                    let emailInError = false;
                    const re = new RegExp(/^ *\S+@\S+\.\S+ *$/);

                    requiredInputs.forEach(function(element) {
                        const inError = (element.value.length < 1);
                        if (inError) {
                            element.classList.add('error');
                            addressesInError = true;
                        } else {
                            element.classList.remove('error');
                        }
                    });

                    if (!re.test(document.getElementById('bill_email').value)) {
                        document.getElementById('bill_email').classList.add('error');
                        emailInError = true;
                    } else {
                        document.getElementById('bill_email').classList.remove('error');
                    }

                    document.getElementById('error_bill_details').classList.toggle('hidden', !addressesInError);
                    document.getElementById('error_bill_email').classList.toggle('hidden', !emailInError);
                    document.getElementById('error_cgv').classList.toggle('hidden', document.querySelector('[name=cgv_check]').checked);
                }

                /* We update the changed field in the DB */
                // Not necessary now: all changes are made in Basket page 
                updateOrderCart(targetName, form).catch(function(error) {
                    console.log("Error updating Order page:", error);
                });
            });
        });

        /**
         * When form is submitted with the button, intercepts submit to validate inputs
         */
        form.addEventListener("submit", function() {
            let inputsValid = true;
            let country;
            let postalCode;

            if (delivery_ckbox.checked) {
                country = delivery_country.value;
                postalCode = document.getElementById('del_zip').value;
            } else {
                country = billing_country.value;
                postalCode = document.getElementById('bill_zip').value;
            }

            if (country == 'france' && postalCode.substring(0, 2) >= 97) {
                // Dept is France with a postal code from DOM TOM
                vb_alert("<p>Vous avez choisi pour la livraison un code postal commençant par 97 ou 98, mais déclaré la destination en France Métropolitaine.</p><p>Merci de corriger l'adresse !</p>");
                inputsValid = false;
            }
            if (country == 'france_dom' && postalCode.substring(0, 2) < 97) {
                // Dept is DOM TOM with a metropolitan postal code
                vb_alert("<p>Vous avez choisi pour la livraison un code postal en Métropole, mais déclaré la destination dans les Départements d'Outre-Mer.<p>Merci de corriger l'adresse !</p>");
                inputsValid = false;
            }
            if (!inputsValid) {
                delivery_country.classList.add('error');
                billing_country.classList.add('error');
                document.getElementById('del_zip').classList.add('error');
                document.getElementById('bill_zip').classList.add('error');
            }

            return inputsValid;
        });

        /**
         * Show & hide payment descriptions when chosen
         * On first paint with Sogenactif, and then on updates
         */
        showPaymentDetails('#sogecom_details');

        const paymentCatInputs = document.querySelectorAll("input[name='payment_cat']");
        paymentCatInputs.forEach(function(input) {
            input.addEventListener('change', function() {
                if (input.checked) {
                    switch (input.value) {
                        case 'sogenactif':
                            // Details different for Sogecommerce & Sogenactif
                            showPaymentDetails('#sogecom_details');
                            break;
                        case 'paypal':
                            // Same details for Paypal2 & Paypal
                            showPaymentDetails('#paypal_details');
                            break;
                        case 'wire':
                            showPaymentDetails('#wire_details');
                            break;
                        case '1_check':
                            showPaymentDetails('#check1_details');
                            break;
                        case '3_checks':
                            showPaymentDetails('#checks3_details');
                            break;
                        default:
                            // No default
                    }
                }
            });
        });
    }
});

/**
 * UTILITIES
 */

function show_delivery_address() {
    document.getElementById('special_delivery').style.display = 'block';
    document.getElementById("special_delivery_check").checked = true;
}

/** BEG Ajax Basket Update */
async function updateBasketCart(targetName, form) {

    // Adjust quantities to Limits
    const qtyInputs = document.querySelectorAll(".qty_input");
    qtyInputs.forEach(function(input) {
        const value = parseInt(input.value, 10) || 1;
        input.value = Math.min(Math.max(value, 1), 100);
    });

    const dataForm = new FormData(form);
    dataForm.append('update_cart', "basket")

    const updatePageRequest = await fetch("/v5_php_modules/v5_order_mgt/v5_process_basket.php", {
        method: "POST",
        body: dataForm
    });

    const response = await updatePageRequest.json();

    const vat_pct_dest = response.vat_pct_dest;

    /* Update the selection and reminder for the destination country */
    document.getElementById('country_selector').value = response.country;
    const countrySelector = document.getElementById('country_selector');
    const selectedCountry = countrySelector.querySelector(`option[value="${response.country}"]`);
    if (document.getElementById('country_string')) {
        // Does not exist in Mobile
        document.getElementById('country_string').textContent = selectedCountry.textContent;
    }

    updateCartLines(response);

    document.getElementById('subtotal_basket_ttc').textContent = response.subtotal_basket_ttc;
    document.getElementById('discount_promo_ttc').textContent = response.discount_promo_ttc;
    const discountAutoTtcElement = document.getElementById('discount_auto_ttc');
    if (discountAutoTtcElement) {
        discountAutoTtcElement.textContent = response.discount_auto_ttc;
    }
    document.getElementById('shipping_ttc').textContent = response.shipping_ttc;
    document.getElementById('vat_dest').textContent = response.vat_amount_charged;
    document.getElementById('vat_pct_dest').textContent = vat_pct_dest;
    document.getElementById('total_ttc').textContent = response.total_ttc;

}

function updateCartLines(response) {
    const nozos = response.line_nozos;
    const cartLines = document.querySelectorAll('.cart_line');
    cartLines.forEach(function(line, index) {
        const lineNozo = line.getAttribute("data-nozo");
        const keepThisLine = nozos.some(e => e == lineNozo);
        if (keepThisLine) {
            line.querySelector(".line_price").textContent = response.line_prices[index];
            line.querySelector(".qty_input").textContent = response.line_qties[index];
            line.querySelector(".item_price").textContent = response.item_prices[index];
        } else {
            line.remove();
        }
    });
}
/** END Ajax Basket Update  */


/**
 * Slides Order page payment details block
 * @param {string} id of payment details to show
 */
function showPaymentDetails(id) {
    const paymentDetailsElements = document.querySelectorAll('.payment_details');
    paymentDetailsElements.forEach(function(element) {
        element.style.display = 'none';
    });
    document.querySelector(id).style.display = 'block';
}

/**
 * Update Order page when the fields are changed
 * @param {string} targetName ("bill_country" ou autre)
 */
async function updateOrderCart(targetName, form) {

    const specialDelivery = document.getElementById("special_delivery_check").checked;
    const dataForm = new FormData(form);
    
    /* del_country must be added manually: FormData does not pick it up since the input is disabled */
    dataForm.append('del_country', document.getElementById('del_country').value);
    dataForm.append('special_delivery', specialDelivery);
    dataForm.append('update_cart', targetName);

    /* 
    for (const pair of dataForm.entries()) {
        console.log(pair[0] + ': ' + pair[1]);
    } */

    const updatePageRequest = await fetch("/v5_php_modules/v5_order_mgt/v5_process_order.php", {
        method: 'POST',
        body: dataForm
    });

    const response = await updatePageRequest.json();
    
    const vat_pct_dest = response.vat_pct_dest;
    const itemPrices = response.item_prices;
    const linePrices = response.line_prices;

    document.getElementById('destination_reminder').textContent = response.country_string;

    const calcItemPrices = document.querySelectorAll('.calc_item_price');
    calcItemPrices.forEach(function(element, index) {
        element.textContent = itemPrices[index];
    });

    const calcLinePrices = document.querySelectorAll('.calc_line_price');
    calcLinePrices.forEach(function(element, index) {
        element.textContent = linePrices[index];
    });

    if (document.getElementById('calc_discount_ttc') !== null) {
        /* Element only exists in DOM if there is a discount */
        document.getElementById('calc_discount_ttc').textContent = response.effective_discount_ttc;
    }
    document.getElementById('calc_shipping_ttc').textContent = response.shipping_ttc;
    document.getElementById('calc_vat_dest').textContent = response.vat_amount_dest;
    document.getElementById('calc_vat_pct_dest').textContent = vat_pct_dest;
    document.getElementById('calc_vat_pct_dest2').textContent = vat_pct_dest;
    document.getElementById('calc_total_ttc').textContent = response.total_ttc;

    /** Enable 3 checks payment if French & amount above 150 € (ttc) */
    //document.getElementById('country_selector').textContent = response.country_string;
    const frenchTerritories = ['france', 'france_dom', 'france_polynesie'];
    const delCountry = document.getElementById('del_country').value;
    const billCountry = document.getElementById('bill_country').value;
    const orderIsFrench = frenchTerritories.includes(delCountry) && frenchTerritories.includes(billCountry);
    const ChecksOrderIsFrench = cur2val(response.total_ttc) > 150 / 1.2 && orderIsFrench;

    udpateOrderCartDetails(specialDelivery);
}

/**
 * Adjusts Order page mini-basket blocks in Order page depending on destination & VAT status
 * @param {string} specialDelivery billing | special | showroom
 */
function udpateOrderCartDetails(specialDelivery) {
    const destination = (specialDelivery ? document.getElementById('del_country').options[document.getElementById('del_country').selectedIndex].text : document.getElementById('bill_country').options[document.getElementById('bill_country').selectedIndex].text);
    
    document.getElementById('destination_reminder').textContent = destination;
}

/**
 * Converts a numeric string to a currency string with 2 decimals
 * @param {string} theString string to convert
 * @return {string} converted string 
 */
function text2cur(theString) {
    return parseFloat(theString).toFixed(2) + ' €';
}

/**
 * Converts a string like "XX XX.XX€" or "XX XX.XX €" into a decimal string
 * @param {string} theString string to convert
 * @return {string} converted string
 */
function cur2val(theString) {
    let theCur = theString.replace(/€| /g, '');
    theCur = theCur.replace(',', '.');
    return parseFloat(theCur);
}

/**
 * Gets the 2 letters country code from liste_pays.json
 * @param {string} country
 * @return {string}: 2 chars country code
 */
function get_country_code(country) {
    return fetch("/v5_config_files/v6_calculated_data_JSON/liste_pays.json")
        .then(function(response) {
            return response.json();
        }).then(function(data) {
            return data[country]['code'];
        });
}

/**
 * Displays a modal dialog with a given message.
 *
 * @param {string} $msg - The message to display in the modal dialog.
 */
function vb_alert(msg) {

    if (typeof HTMLDialogElement === 'function') {
        dialogAlert(msg);
    } else {
        legacyAlert(msg);
    }
}

/** html 5 dialog */
function dialogAlert(msg) {

    const dialog = document.querySelector("dialog");
    const closeButton = document.querySelector("dialog button");
    const modal_msg = document.getElementById('modal_msg');

    modal_msg.innerHTML = msg;

    // "Show the dialog" button opens the dialog modally
    dialog.showModal();

    // "Close" button closes the dialog
    closeButton.addEventListener("click", () => {
        dialog.close()
    });
}

/** Polyfill for older browsers */
function legacyAlert (msg) {
    const fallbackModal = document.createElement('div');
    fallbackModal.innerHTML = msg;
    fallbackModal.style.position = 'fixed';
    fallbackModal.style.top = '50%';
    fallbackModal.style.left = '50%';
    fallbackModal.style.transform = 'translate(-50%, -50%)';
    fallbackModal.style.padding = '20px';
    fallbackModal.style.backgroundColor = 'white';
    fallbackModal.style.boxShadow = '8px 8px 8px rgba(90, 90, 90, .6)';
    fallbackModal.style.border = '4px solid rgba(90, 90, 90)';
    fallbackModal.style.borderRadius = '8px';  
    fallbackModal.style.zIndex = '1000';

    // Create the close button
    const closeButton = document.createElement('button');
    closeButton.textContent = 'Close';
    closeButton.style.marginTop = '10px';
    closeButton.style.padding = '5px 10px';
    closeButton.style.backgroundColor = '#f0f0f0';
    closeButton.style.border = '1px solid #ccc';
    closeButton.style.cursor = 'pointer';
    closeButton.style.float = 'right';


    // Add event listener to close the modal
    closeButton.addEventListener('click', () => {
        document.body.removeChild(fallbackModal);
    });

    // Append the close button to the modal
    fallbackModal.appendChild(closeButton);

    document.body.appendChild(fallbackModal);
}


/* Alternative modal, creating the element from scratch
function vb_alert_old(msg) {
    // Example usage of <dialog>
    const dialog = document.createElement('dialog');
    dialog.textContent = msg;
    document.body.appendChild(dialog);
    dialog.showModal();
} */
